import { CHANNEL_TYPES } from '@/common/constants/channel';
import { PERMISSION_CONFIGS } from '@/common/constants/permission';
import { getUserPermissions } from '_api/role'
import { mapGetters } from 'vuex'
import { transformToBinaryList } from '_lib/utils/utilsArray';

function judgeAllow (allow, channel_type) {
  let allow_list = transformToBinaryList(allow, PERMISSION_CONFIGS.length)
  const viewingChannelIndex = PERMISSION_CONFIGS.findIndex(item => item.key === 'ViewingChannel')
  const canViewingChannel = !!allow_list[viewingChannelIndex]
  if (channel_type === CHANNEL_TYPES.audio) {
    const joinAudioChannelIndex = PERMISSION_CONFIGS.findIndex(item => item.key === 'JoinAudioChannel')
    if (canViewingChannel && allow_list[joinAudioChannelIndex]) {
      return true
    }
  } else {
    if (canViewingChannel) {
      return true
    }
  }
  return false
}

export function getPriviateRoles(channel_data, cur_roles_list, admin_role_ids) { 
  let roles = []
  const permission_overwrites = channel_data.permission_overwrites || []
  cur_roles_list.forEach(item => {
    let overwrite = permission_overwrites.find(o => o.role_id == item.id)
    if (!overwrite) {
      overwrite = {
        allow: 0,
        deny: 0,
        role_id: item.id
      }
    }
    if (judgeAllow(overwrite.allow, channel_data.channel_type)) {
      roles.push(item)
    }
  })
  const manageServerRoles = cur_roles_list.filter(role => {
    return admin_role_ids.includes(role.id)
  })
  let selectedRoles = [...manageServerRoles, ...roles]
  // 去重selectedRoles
  selectedRoles = selectedRoles.reduce((acc, cur) => {
    const ids = acc.map(item => item.id)
    if (!ids.includes(cur.id)) {
      acc.push(cur)
    }
    return acc
  }, [])
  return selectedRoles
}

export async function getPrivateMembers (cur_room_data, channel_data) {
  const res = await getUserPermissions({
    room_id: cur_room_data.room_id,
    channel_id: channel_data.channel_id
  })
  if (res.data.status == 'ok') {
    const members = res.data.result.users_perm || []
    const result = []
    members.forEach(item => {
      const allow = item.allow
      if (!item.bot && cur_room_data.create_by === item.user_id || judgeAllow(allow, channel_data.channel_type)) {
        result.push(item)
      }
    })
    return result
  }
  return []
}
export default {
  computed: {
    // 所有有管理员权限的权限组
    admin_role_ids () {
      const admin_roles = this.cur_roles_list.filter(role => {
        return this.$permission.judgeRole({
          role,
          channel_data: this.channel_data,
          type: 'ManageServer'
        })
      })
      if (admin_roles.length) {
        return admin_roles.map(role => role.id)
      }
      return []
    },
    ...mapGetters(['cur_roles_list'])
  },
  methods: {
    getPriviateRoles() { 
      return getPriviateRoles(this.channel_data, this.cur_roles_list, this.admin_role_ids)
    },
    // 完整的私有频道成员，带allow和deny
    async getPrivateMembers () {
      return getPrivateMembers(this.cur_room_data, this.channel_data)
    },
  }
}